import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home.vue'
import { stakeRoutes } from '@/app/stakes/stakeRoutes'
import { wardRoutes } from '@/app/wards/wardRoutes'
import { userRoutes } from '@/app/users/userRoutes'
import { messageRoutes } from '@/app/messages/messageRoutes';
import { authRoutes } from "@/views/auth/authRoutes";
import { CarrierRoutes } from '@/app/carriers/carrierRoutes';
import { organizationRoutes } from '@/app/organizations/organizationRoutes';
import store from '@/store'

Vue.use(Router)

const { BASE_URL } = process.env

const router = new Router({
  mode: "history",
  base: BASE_URL,
  routes: [
    {
      name: "login",
      path: "/login",
      component: ()=> import("@/views/Login"),
      props: true,
      meta: {showHeaderAndFooter: true}
    },
    {
      name: "logout",
      path: "/logout",
      component: ()=> import("@/views/Logout"),
      props: true,
      meta: {showHeaderAndFooter: true}
    },
    {
      name: "home",
      path: "/",
      component: ()=> import("@/views/Home"),
      props: true,
      meta: {showHeaderAndFooter: true}
    },
    {
      name: "about",
      path: "/about",
      component: ()=> import("@/views/About"),
      props: true,
      meta: {showHeaderAndFooter: true}

    },
    {
      name: "contact",
      path: "/contact",
      component: ()=> import("@/views/Contact"),
      props: true,
      meta: {showHeaderAndFooter: true}

    },
    {
      name: "features",
      path: "/features",
      component: () => import("@/views/Features"),
      props: true,
      meta: {showHeaderAndFooter: true}
    },
    ...stakeRoutes,
    ...wardRoutes,
    ...userRoutes,
    ...authRoutes,
    ...messageRoutes,
    ...CarrierRoutes,
    ...organizationRoutes
  ]
})
// check if user is logged in before sending to page that requires authentication

//router.beforeEach((to, from, next)=>{
//  if(to.name !== "login" && !store.state.user.logged_in)
//    next({ name: 'logout' })
//  else
//    next()
//});

export default router;
